import type { OnboardingSetupForm } from '@/types/onboarding';

import { requestJson } from './requests';

export interface OnboardingSetupResponse {
  ok: boolean;
  runId: string;
  status: 'completed' | 'processing' | 'failed';
  nextPath: string;
  tenantSlug: string;
}

export const submitOnboardingSetup = (
  payload: OnboardingSetupForm,
): Promise<OnboardingSetupResponse> =>
  requestJson<OnboardingSetupResponse>('/api/onboarding/setup', {
    method: 'POST',
    body: payload,
  });
